define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    /**
     * Created by reunion on 23/10/2017.
     */
    var DataSchema = /** @class */ (function () {
        function DataSchema() {
            this.version = 0;
        }
        DataSchema.prototype.validateModel = function (object, version) {
            if (version === void 0) { version = null; }
            console.log("validateModel must be implemented in DataSchema sub-class");
            return false;
        };
        ;
        DataSchema.prototype.generateModel = function (version) {
            if (version === void 0) { version = null; }
            console.log("generateModel must be implemented in DataSchema sub-class");
            return null;
        };
        ;
        return DataSchema;
    }());
    exports.DataSchema = DataSchema;
});
